























/* General */
import Vue from 'vue'

/* Mixins */

/* Components */

/* Helpers */

/* Data types */
import {
  IStatusForSelection,
  IWorkflowForSelection,
} from '@/api/types/response.types'
import { IStatusMapping } from '@/api/types/request.types'

/* API */

export default Vue.extend({
  name: 'EntityWorkflowStatusMapper',

  props: {
    statusMappings: {
      type: Array as () => IStatusMapping[],
      required: true,
    },
    currentWorkflow: {
      type: Object as () => IWorkflowForSelection,
      required: true,
    },
    newWorkflow: {
      type: Object as () => IWorkflowForSelection,
      default: null,
    },
  },

  data() {
    return {
      statusMappingsInitialized: false,
      newWorkflowStatusesWithNullOption: [] as IStatusForSelection[],
    }
  },

  computed: {
    internalStatusMappings: {
      get(): IStatusMapping[] {
        return this.statusMappings
      },
      set(value: IStatusMapping[]) {
        this.$emit('update:statusMappings', value)
      },
    },
  },
  watch: {
    newWorkflow: {
      immediate: true,
      handler(val: IWorkflowForSelection) {
        this.statusMappingsInitialized = false
        const newMappings = [] as IStatusMapping[]

        this.newWorkflowStatusesWithNullOption = []
        this.newWorkflowStatusesWithNullOption.push({
          id: null,
          name: 'Select a status...',
          color: 'bluish-grey',
        })
        this.newWorkflowStatusesWithNullOption.push(...val.listStatuses)

        this.currentWorkflow.listStatuses.forEach(c => {
          const newStatusCandidate = this.newWorkflow.listStatuses.find(
            n => c.name.toLowerCase().trim() === n.name.toLowerCase().trim(),
          )
          const newStatusIDCandidate = newStatusCandidate
            ? newStatusCandidate.id
            : null

          newMappings.push({
            oldStatusID: c.id,
            newStatusID: newStatusIDCandidate,
          })
        })

        this.internalStatusMappings = newMappings
        this.$nextTick(() => {
          this.statusMappingsInitialized = true
        })
      },
    },
  },
})
